import { Component, Input, OnInit } from '@angular/core';

import { DestroyerBase } from '@core/base/destroyer/destroyer.base';
import { ModalsService } from '@core/services/modals/modals.service';
import { Router } from '@angular/router';
import { RouterHelperService } from '@core/services/router-helper/router-helper.service';
import { FidelityType } from '@shared/modals/kiosk-fidelity-registration/fidelity-type.enum';
import { ZerosixRegistrationStep } from './zerosix-registration-step.enum';
import { IContentBuilderFieldColor } from '@core/models/content-builder-fields.model';
import { ColorFieldTypesValues } from '@config/values/color-field-types.values';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';

@Component({
  selector: 'app-zerosix-registration-modal',
  templateUrl: './zerosix-registration-modal.component.html',
})
export class ZerosixRegistrationModalComponent extends DestroyerBase implements OnInit {
  static handle = 'zerosix-registration-modal';

  phone?: string;
  @Input() goToURLOnClose?: string;
  @Input() goToKioskRegister?: boolean = false;
  registrationStep = ZerosixRegistrationStep;
  @Input() activeStep = this.registrationStep.ZEROSIX_STEP_PHONE;

  @Input()
  actionFontColor?: IContentBuilderFieldColor | string | undefined;

  @Input()
  actionBackgroundColor?: IContentBuilderFieldColor | string | undefined;

  get actionFieldColor(): ContentBuilderFieldColors | undefined {
    const font = this.actionFontColor;
    const background = this.actionBackgroundColor;
    if (!font && !background) {
      return undefined;
    }
    return {
      font: this.getFormattedFontColor(font),
      background: this.getFormattedBackgroundColor(background),
    };
  }

  public readonly FidelityType = FidelityType;

  constructor(
    private readonly modalsService: ModalsService,
    private readonly router: Router,
    private readonly routerHelper: RouterHelperService,
  ) {
    super();
  }

  private getFormattedFontColor(font: string | IContentBuilderFieldColor | undefined) {
    if (typeof font === 'string') {
      return font.startsWith('#')
        ? {
            type: ColorFieldTypesValues.Hex,
            value: font,
          }
        : {
            type: ColorFieldTypesValues.Palette,
            value: font,
          };
    }
    return font;
  }

  private getFormattedBackgroundColor(background: string | IContentBuilderFieldColor | undefined) {
    if (typeof background === 'string') {
      return background.startsWith('#')
        ? {
            type: ColorFieldTypesValues.Hex,
            value: background,
          }
        : {
            type: ColorFieldTypesValues.Palette,
            value: background,
          };
    }
    return background;
  }

  ngOnInit() {
    if (this.goToKioskRegister) {
      this.onGoToRegisterStep();
    }
  }

  onClose(): void {
    this.modalsService.close(ZerosixRegistrationModalComponent.handle);
  }

  onComplete(): void {
    this.onClose();
    if (this.goToURLOnClose) {
      this.router.navigate([
        this.goToURLOnClose
          ? this.routerHelper.translateRoute(this.goToURLOnClose)
          : this.goToURLOnClose,
      ]);
    }
  }

  onGoToOtpStep(): void {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_OTP;
  }

  setPhone(phone: string): void {
    this.phone = phone;
    this.activeStep = this.registrationStep.ZEROSIX_STEP_ACCOUNT_NOT_FOUND;
  }

  onGoToAccountNotFoundStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_ACCOUNT_NOT_FOUND;
  }

  onGoToPhoneStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_PHONE;
  }

  onGoToAuthenticationStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_AUTHENTICATION;
  }

  onGoToConfirmationStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_KIOSK_CONFIRMATION;
  }

  onGoToRegisterStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_KIOSK_REGISTER;
  }

  onGoToKioskRegisterConfirmationStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_KIOSK_REGISTER_CONFIRMATION;
  }

  onGoToKioskRegistrationSuccessStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_KIOSK_REGISTRATION_SUCCESS;
  }

  onGoToKioskAccountNotFoundStep() {
    this.activeStep = this.registrationStep.ZEROSIX_STEP_KIOSK_ACCOUNT_NOT_FOUND;
  }
}
